// extracted by mini-css-extract-plugin
export default {"container":"src-styles-portfolio-__highlighted_text__container__dadS8"};